// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_iW","advertCardHeader__actions":"c-a_iX","advertCardHeader__bottomLabel":"c-a_iY"};